import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { EmployeEntite } from '../entites/employe';
import { MembreEmplacement } from '../entites/membre-emplacement';
import { EmplacementCourantService } from '../services/emplacement-courant.service';

/**
 * Reusable component to display an employee name with their current emplacement.
 * The emplacement is loaded deferred when the component becomes visible.
 */
@Component({
  selector: 'app-employe-avec-emplacement',
  template: `
    <div class="flex flex-column">
      <span>{{ employe | nomEmploye }}</span>
      @defer (on viewport) {
        <span *ngIf="emplacement" class="text-xs text-500 flex align-items-center gap-1">
          <i class="pi pi-map-marker text-xs"></i>
          {{ emplacement.emplacement?.nom }}
        </span>
        <span *ngIf="loading" class="text-xs">
          <p-skeleton width="80px" height="12px"></p-skeleton>
        </span>
      } @placeholder {
        <span class="text-xs">
          <p-skeleton width="80px" height="12px"></p-skeleton>
        </span>
      }
    </div>
  `,
  styles: [`
    :host {
      display: inline-block;
    }
  `]
})
export class EmployeAvecEmplacementComponent implements OnInit, OnDestroy {
  @Input({ required: true }) employe!: EmployeEntite;

  emplacement: MembreEmplacement | null = null;
  loading = true;

  private subscription?: Subscription;

  constructor(private emplacementCourantService: EmplacementCourantService) {}

  ngOnInit(): void {
    if (this.employe?.employeId) {
      this.subscription = this.emplacementCourantService
        .getEmplacementCourant(this.employe.employeId)
        .subscribe(result => {
          this.emplacement = result;
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}

